// extracted by mini-css-extract-plugin
module.exports = {"tablepd":"index_tablepd_1-M8H","locked":"index_locked_3_bMb"};